<div class="auth-container">
  <div class="auth-card">
    <div class="auth-header">
      <p class="auth-eyebrow">SpecTrace</p>
      <h2>Create account</h2>
      <p class="auth-subtitle">Set up your profile to host and join sessions.</p>
    </div>
    <form class="auth-form" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="nickname">Nickname</label>
        <input
          type="text"
          id="nickname"
          [(ngModel)]="nickname"
          name="nickname"
          autocomplete="nickname"
          maxlength="32"
          required
        />
      </div>
      <div class="form-group">
        <label for="email">Email</label>
        <input type="email" id="email" [(ngModel)]="email" name="email" autocomplete="email" required />
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          [(ngModel)]="password"
          name="password"
          autocomplete="new-password"
          required
        />
      </div>
      <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          [(ngModel)]="confirmPassword"
          name="confirmPassword"
          autocomplete="new-password"
          required
        />
      </div>
      <div class="legal-consent-group">
        <label class="checkbox-label" for="legalConsent">
          <input
            type="checkbox"
            id="legalConsent"
            name="legalConsent"
            [(ngModel)]="hasAcceptedLegal"
            required
          />
          <span>
            I confirm that I have read and agree to the
            <a href="https://spectrace.app/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            and
            <a href="https://spectrace.app/terms" target="_blank" rel="noopener noreferrer">Terms</a>.
          </span>
        </label>
      </div>
      <div class="error-message" *ngIf="error">{{ error }}</div>
      <div class="info-message" *ngIf="info">{{ info }}</div>
      <button class="primary-button" type="submit" [disabled]="isLoading || googleLoading || !hasAcceptedLegal">
        {{ isLoading ? 'Registering...' : 'Register' }}
      </button>
    </form>
    <div class="divider">or</div>
    <button class="google-button" [disabled]="googleLoading || isLoading" (click)="onGoogleRegister()">
      {{ googleLoading ? 'Redirecting...' : 'Continue with Google' }}
    </button>
    <p class="auth-link">
      Already have an account? <a routerLink="/login">Login here</a>
    </p>
  </div>
</div>
